import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { IPropertyError, NodeDropDownSectionProps } from 'types/rofl';
import { getValidationError } from 'util/errors';

import { NodeDropDownSection, defaultDropDownSearch } from '../../NodeDropDownSection/NodeDropDownSection';


/**
* FieldSelectorProps represents the base props for the FieldSelector component
*/
export interface FieldSelectorProps {
    entityTitle?: string;
    children?: React.ReactNode; // nested field content
    hideNodeDropDown?: boolean;
    nodeDropDownProps: NodeDropDownSectionProps;
    deletable?: boolean;
    onDelete?: () => void;
    propertyError?: IPropertyError;
}

/**
 *  This component represents a fieldselector. It can dynamically render content based off of a choice
 *  in the dropdown.
 */
export const FieldSelector = (props: FieldSelectorProps) => {
    const { children, nodeDropDownProps, deletable, onDelete, propertyError, entityTitle, hideNodeDropDown } = props;
    const [error, setError] = useState<string>();
    const isDeletable = deletable && onDelete !== undefined;

    const setInitialPropertyError = useRef(() => {
        if (propertyError?.error) {
            setError(getValidationError(propertyError.error, entityTitle ?? ''));
        }
    });
    useEffect(() => {
        setInitialPropertyError.current();
    }, []);

    // default search callback
    nodeDropDownProps.onSearch = nodeDropDownProps.onSearch || defaultDropDownSearch;


    return (
        <div className='field-selector' data-testid='field-selector'>
            <div
                className={classNames(
                    'field-selector-dropdown',
                    { deletable: isDeletable })}
            >
                {
                    !hideNodeDropDown && (
                        <NodeDropDownSection
                            {...nodeDropDownProps}
                        />
                    )
                }
                {isDeletable && (
                    <i
                        className='fa fa-trash'
                        onClick={onDelete}
                        data-testid='field-selector-delete-icon'
                    />
                )}
            </div>
            {children && (
                <div className='field-selector-children-container'>
                    {children}
                </div>
            )}
            {error && (
                <>
                    <hr />
                    <span className='field-selector-error-msg'>
                        { error }
                    </span>
                    <hr />
                </>
            )}
        </div>
    );
};
